import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { ModalDeleteComponent } from 'src/app/utils/modal-delete/modal-delete.component';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { TipoActualizacionCreateComponent } from '../tipo-actualizacion-create/tipo-actualizacion-create.component';
import { TipoActualizacionUpdateComponent } from '../tipo-actualizacion-update/tipo-actualizacion-update.component';
import { TipoActualizacionService } from '../tipo-actualizacion.service';

@Component({
  selector: 'app-tipo-actualizacion-index',
  templateUrl: './tipo-actualizacion-index.component.html',
  styles: [
  ]
})
export class TipoActualizacionIndexComponent implements OnInit {

  url: string = '';

  reloadEmitter: EventEmitter<string> = new EventEmitter();

  filtros = [
    {
      label: 'Nombre',
      column: 'nombre',
      op: 'substring'
    },
    {
      label: 'Descripción',
      column: 'descripcion',
      op: 'substring'
    }
  ]

  acciones = [
    {
      label: 'Editar',
      icon: 'pen',
      action: (element: any) => {
        this.edit(element)
      },
    },
    {
      icon: "trash",
      label: "Eliminar",
      action: (element: any) => {
        this.delete(element);
      }
    }
  ]

  columnas = [
    {
      label: 'Nombre',
      attribute: 'nombre',
      width: 1,
      responsive: ['XS', 'SM', 'MD'],
      value: (element: any) => {
        return element.nombre;
      }
    },
    {
      label: 'Descripción',
      attribute: 'descripcion',
      width: 2,
      responsive: ['SM', 'MD'],
      value: (element: any) => {
        return element.descripcion;
      }
    }
  ]
  
  constructor(
    public config: ConfigService,
    private modalService: NgbModal,
    public loading: LoadingService,
    private alerts: AlertService,
    public service: TipoActualizacionService,
    public sesion: SesionService
  ) { }

  ngOnInit(): void {
    this.url = this.config.apiUrl + this.service.controller + 'ver';
  }

  loadData(): void {
    this.reloadEmitter.emit();
  }

  add(): void {
    const modalRef = this.modalService.open(TipoActualizacionCreateComponent, { windowClass: 'clear-modal', size: 'lg', scrollable: true, backdrop: 'static' });
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  edit(element: any): void {
    const modalRef = this.modalService.open(TipoActualizacionUpdateComponent, { windowClass: 'clear-modal', size: 'lg', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.element = element;
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  delete(element: any): void {
    const modalRef = this.modalService.open(ModalDeleteComponent, { windowClass: 'clear-modal', size: 'md', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Eliminar Tipo de Actualización';
    modalRef.componentInstance.texto = `¿Seguro que desea eliminar el tipo de actualización "${element.nombre}"?`;
    modalRef.componentInstance.textoAceptar = 'Eliminar';
    modalRef.result.then((result: any) => {
      this.loading.show();
      this.service.delete(element.id).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.loadData();
          this.alerts.addAlert("Tipo de Actualización eliminado con éxito.", "success");
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido eliminar el registro de Tipo de Actualización.", "danger");
        }
      });
    }, (reason: any) => { });
  }
}
